import { render, staticRenderFns } from "./ontick-loading-screen.component.vue?vue&type=template&id=21c83f62&scoped=true"
import script from "./ontick-loading-screen.component.vue?vue&type=script&lang=js"
export * from "./ontick-loading-screen.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c83f62",
  null
  
)

export default component.exports